/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Durchfuehrungstage1Inputs */

const de__field_durchfuehrungstage1 = /** @type {(inputs: _Field_Durchfuehrungstage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchführungstage`)
};

/**

* @param {_Field_Durchfuehrungstage1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_durchfuehrungstage1 = /** @type {((inputs?: _Field_Durchfuehrungstage1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Durchfuehrungstage1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_durchfuehrungstage1(inputs)
});
export { _field_durchfuehrungstage1 as "_field_durchfuehrungsTage" }